// extracted by mini-css-extract-plugin
module.exports = {"hero":"hero-module--hero--S__gH","inner":"hero-module--inner--2tB_i"};